import React from 'react';
import PropTypes from 'prop-types';
import './DivLayoutV2.css';

const DivLayoutV2NestedSection = ({ title, children }) => (
  <div className="div-layout-v2-nested-section">
    {title && <h6 className="div-layout-v2-nested-title">{title}</h6>}
    {children}
  </div>
);

DivLayoutV2NestedSection.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default DivLayoutV2NestedSection;
